import { BrowserRouter, HashRouter } from 'react-router-dom';
import isElectron from 'is-electron';
import { ProvidersProps } from '../providers.types';

const Router = isElectron() ? HashRouter : BrowserRouter;

const RouterProvider: React.FC<ProvidersProps> = ({ children }) => (
  <Router>{children}</Router>
);

export default RouterProvider;
